export var COMPONENT_NAME = 'ElegantEnhancements';